import script from "./GlobalSearchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSearchModal.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSearchModal.vue?vue&type=style&index=0&id=25bd70a4&lang=scss&scoped=true"
script.__scopeId = "data-v-25bd70a4"

export default script